import axios from 'axios'
import conf from './_conf'
import authInterceptor from './_interceptor/auth.interceptor'
import { responseSuccessInterceptor, responseErrorInterceptor } from './_interceptor/response.interceptor'

const http = axios.create({
  baseURL: conf.BASE_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截
http.interceptors.request.use(
  conf => authInterceptor(conf),
  error => {
    return Promise.reject(error)
  }
)

// 返回拦截
http.interceptors.response.use(
  response => responseSuccessInterceptor(response),
  error => responseErrorInterceptor(error)
)

export default http
